/**
 * Shared route exclusion rules for marketing analytics (Meta Pixel, GTM, Clarity).
 * The Clarity bootstrap in public/index.html mirrors these paths for the first load.
 */

export const MARKETING_EXCLUDED_PATH_PREFIXES = [
  '/admin',
  '/ticket/',
  '/b/',
];

export const MARKETING_EXCLUDED_EXACT_PATHS = new Set([
  '/account',
  '/my-trips',
  '/e-ticket',
  '/view-booking-details',
  '/test-animation',
  '/seat-map-demo',
  '/seat-selection-demo',
  '/flight-search-results-demo',
  '/yovo-trip-header',
  '/flight-search-header',
  '/flight-fare-card',
  '/flight_book',
  '/flight-card',
  '/fare-plans',
]);

/**
 * @param {string | undefined | null} pathname
 * @returns {string}
 */
function normalizePathname(pathname) {
  return (pathname || '/').replace(/\/+$/, '') || '/';
}

/**
 * Dedupe key for SPA PageView tracking.
 * React Router provides a stable location.search string per navigation.
 *
 * @param {string | undefined | null} pathname
 * @param {string | undefined | null} search
 * @returns {string}
 */
export function buildMarketingPageViewKey(pathname, search) {
  return `${pathname || '/'}${search || ''}`;
}

/**
 * @param {string | undefined | null} pathname
 * @returns {boolean}
 */
export function shouldTrackMarketingPageView(pathname) {
  const path = normalizePathname(pathname);

  if (MARKETING_EXCLUDED_EXACT_PATHS.has(path)) {
    return false;
  }

  for (const prefix of MARKETING_EXCLUDED_PATH_PREFIXES) {
    if (path.startsWith(prefix)) {
      return false;
    }
  }

  return true;
}
